export default "__VITE_ASSET__CZHL0$YJ__"